import { render, staticRenderFns } from "./DialogManageWidgetComponent.vue?vue&type=template&id=d624d484&"
import script from "./DialogManageWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./DialogManageWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogManageWidgetComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports